import { FC } from 'react';

import { PrivateDocumentCategory as PrivateDocumentCategoryType } from '@/shared/lib/sj-orm/models/document/private.document.dto';

import { useI18nValues } from '../hooks/useI18nValues';

type PrivateDocumentCategoryProps = {
  category: PrivateDocumentCategoryType;
};

export const PrivateDocumentCategory: FC<PrivateDocumentCategoryProps> = ({ category }) => {
  const values = useI18nValues();

  return <>{values.category(category)}</>;
};
